module.exports = __webpack_public_path__ + "static/media/2en.42610057.jpg";